import { render, staticRenderFns } from "./SimilarPeople.vue?vue&type=template&id=0d751718&scoped=true&"
import script from "./SimilarPeople.vue?vue&type=script&lang=js&"
export * from "./SimilarPeople.vue?vue&type=script&lang=js&"
import style0 from "./SimilarPeople.vue?vue&type=style&index=0&id=0d751718&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d751718",
  null
  
)

export default component.exports